import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getArenaViewToggleStyles = (theme: Theme) =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      gap: 4,
      backgroundColor: theme.background.card,
      borderRadius: 999,
      padding: 3,
      alignSelf: 'center',
      // Fixed chrome above the list: every pixel here is taken from the list's scroll area,
      // so keep the strip tight against the header.
      marginHorizontal: 16,
      marginTop: 2,
      marginBottom: 6,
      maxWidth: '100%',
    },
    pill: {
      paddingHorizontal: 14,
      paddingVertical: 6,
      borderRadius: 999,
      flexShrink: 1,
    },
    pillActive: {
      backgroundColor: theme.primary,
    },
    pillPressed: {
      opacity: 0.8,
    },
    label: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[500],
    },
    labelActive: {
      color: theme.onPrimary,
    },
  });
